import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from './retreatsData';

const MOMENTS = [
  { img: IMAGES.costaRica2026, alt: 'The Costa Rica group' },
  { img: IMAGES.costaRica1, alt: 'Costa Rica retreat moment' },
  { img: IMAGES.costaRica2, alt: 'Costa Rica nature' },
  { img: IMAGES.costaRica3, alt: 'Costa Rica sanctuary' },
  { img: IMAGES.costaRica4, alt: 'River clay ritual — sisters side by side' },
  { img: IMAGES.sacredMoment, alt: 'Morning movement in the open-air pavilion' },
];

export const CostaRicaFeature = () => (
  <section id="costa-rica" className="py-20 px-6 bg-forest text-white" data-testid="costa-rica-feature">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <Badge className="bg-terracotta text-white mb-4">Featured Retrospective</Badge>
        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-2">
          Just Be: <span className="text-terracotta">Soft Power™</span>
        </h2>
        <p className="text-white/70 font-medium tracking-widest uppercase text-sm">Costa Rica 2026</p>
      </div>

      <div className="max-w-3xl mx-auto text-center mb-12 space-y-4 text-lg text-white/90 leading-relaxed">
        <p className="font-heading text-xl md:text-2xl text-white">
          Six days. 18 women. One invitation: stop striving and experience the power of softness.
        </p>
        <p>
          At Imiloa Institute in the Costa Rican rainforest, Sister Diamonds created an immersive journey of rest,
          release, reflection, sisterhood, purpose, and legacy.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
        {MOMENTS.map((m, i) => (
          <img
            key={m.img}
            src={m.img}
            alt={m.alt}
            className={`rounded-2xl w-full object-cover ${i === 0 ? 'col-span-2 md:col-span-1 h-64' : 'h-64'}`}
            loading="lazy"
          />
        ))}
      </div>

      <div className="text-center">
        <Link to="/retreats/costa-rica-2026">
          <Button size="lg" className="bg-terracotta hover:bg-terracotta/90 text-white px-8" data-testid="see-costa-rica-btn">
            See the Costa Rica Experience <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);
